module.exports = __webpack_public_path__ + "static/EPD-logo_simp_chi-beb0b35692c615afd069db56be518fdc.jpg";